import React from 'react'
import { Table, Modal } from 'antd'
import { TableRowModalEditButton } from '../../../components/AppButton'
import { TYPE_CHAT_LABELS } from '../../../shared/utils/constant'

class ItemListTable extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick(idnum) {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okText: 'Да',
      cancelText: 'Отмена',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    console.log(...this.props)
    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: true,
      }, {
        title: 'Тип',
        dataIndex: 'n_type',
        key: 'n_type',
        sorter: true,
        render: record => (
          TYPE_CHAT_LABELS[Number(record)]
        ),
      }, {
        title: 'URL',
        dataIndex: 's_url',
        key: 's_url',
        sorter: true,
      }, {
        title: 'Редактирование',
        key: 'action',
        render: (row, record) => (
          <span>
            <TableRowModalEditButton
              onClick={() => this.props.setActiveChat(record, true)}
            />
          </span>
        ),
      },
    ]
    return (
      <div>
        <Table
          rowKey={record => `item-row-${record.idnum}`}
          columns={columns}
          size='middle'
          {...this.props}
        />
      </div>
    )
  }
}

export default ItemListTable



// WEBPACK FOOTER //
// src/containers/SellerForm/ChatList/Table.jsx